/**
 * オーサリングインタラクションエラー種別
 */
export var InteractionErrors;

(function (InteractionErrors) {
  /**
   * エラーなし
   */
  InteractionErrors[InteractionErrors["NoError"] = 0] = "NoError";
  /**
   * アイテム未選択
   */

  InteractionErrors[InteractionErrors["NoItemsSelected"] = 1] = "NoItemsSelected";
  /**
   * 同一アイテム選択
   */

  InteractionErrors[InteractionErrors["SameItemsSelected"] = 2] = "SameItemsSelected";
})(InteractionErrors || (InteractionErrors = {}));